import { createContext } from "react";

type GlobalLoadingContextType = {
  isGloballyLoading?: boolean;
};

export const GlobalLoadingContext = createContext<GlobalLoadingContextType>({
  isGloballyLoading: true,
});
